import {FC} from "react";
import {ProjectVisit} from "../../api/dto/ProjectVisit";
import {Badge, BadgeStyle} from "./Badge";

export const ProjectVisitBadge: FC<{ visit: ProjectVisit['status'] }> = (props) => {
  return <Badge style={{
    'Concept': BadgeStyle.default,
    'Taak aangemaakt': BadgeStyle.warning,
    'Ingepland': BadgeStyle.info,
    'Uitgevoerd': BadgeStyle.success,
  }[props.visit]}>{{
    'Concept': 'Concept',
    'Taak aangemaakt': 'Taak aangemaakt',
    'Ingepland': 'Ingepland',
    'Uitgevoerd': 'Uitgevoerd'
  }[props.visit]}</Badge>
}